<template>
<header id="header" class="mb-5">
  <b-navbar type="dark" variant="dark" class="bg-mittelab">
    <b-navbar-brand :href="home">
      <img src="./logo_pin.svg" class="mr-2">
      Self Service Account
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto">
      <a class="nav-link text-light" :href="login">Login</a>
    </b-navbar-nav>
  </b-navbar>
</header>
</template>

<script>
export default {
  data() {
    return {
      home: process.env.VUE_APP_MITTELAB_HOME || '/',
      login: process.env.VUE_APP_MITTELAB_LOGIN || '/'
    }
  }
}
</script>
